/* LE stands for line_engineering. le_window & le_door are types identified by IMUP
For window, it's clear enough, for doors, we do not know exact type.
User will be prompt to choose type of the door on FE (opening-type-choice-radiobuttons.tsx) */
export const IMUP_WINDOW_AND_DOOR_TYPES_LABELS = {
    le_window: 'Window',
    le_door: 'Door',
    le_unknown: 'Windows And Doors',
    patio: 'Patio Door',
    entryDoor: 'Entry Door',
    sidelight: 'Sidelight',
    //interiorDoor: 'Interior Door', commented out because it's not implemented in IMUP yet
}

export const IMUP_WINDOW_AND_DOOR_TYPES = [
    'window',
    'patio',
    'entryDoor',
    'interiorDoor',
    'le_window',
    'le_door',
    'le_unknown',
    'sidelight',
]

/**
 * Original drawable types that comes from backend
 */
export enum DRAWABLE_TYPES {
    APPLIANCE = 'appliance',
    EXTERIOR_DOOR = 'exterior_door',
    INTERIOR_DOOR_IMUP = 'interior_door',
    SIDING = 'siding',
    ROOFING = 'roofing',
    TRIM = 'trim',
    CORNER = 'corner',
    POST_WRAP = 'post_wrap',
    PLUMBING_FIXTURE = 'plumbing_fixture',
    STAIR = 'stair',
    STAIRS = 'stairs',
    POST = 'post',
    STEEL_BEAM_PLATE = 'steel_beam_plate',
    LF_RAILING = 'lf_railing',
    HARDWARE = 'hardware',

    // Wall Types
    WALL = 'wall',
    KING_STUD = 'king_stud',
    SHEARWALL = 'shearwall',

    // Floor and roof systems
    ROOF_SYSTEMS = 'roof_systems',
    ROOF_SYSTEM = 'roof_system',
    FLOOR_SYSTEM = 'floor_system',
    FLOOR_SYSTEMS = 'floor_systems',
    RIMBOARD = 'rimboard',
    FLOOR_TRUSS_BRACING = 'floor_truss_bracing',

    INTERIOR_FINISHED_CEILING = 'interior_finished_ceiling',
    BASEMENT_FINISHED_CEILING = 'basement_finished_ceiling',
    LEDGER = 'ledger',
    BLOCKING = 'blocking',
    BEAM = 'beam',
    LF_FIVE_DOT_FIVE_DECKING = 'lf_fivedotfive_decking',
    LF_SCREEN_OPENING = 'lf_screen_opening',
    FOUNDATION_PILON = 'foundation_pilon',
    TRAYED_CEILING_AND_SOFFIT = 'trayed_ceiling_and_soffit',
    FYPON_BRACKET = 'fypon_bracket',
    GABLE_AREA = 'gable_area',
    FLOOR_AREA = 'floor_area',
    GARAGE_AREA = 'garage_area',
    CANALES = 'canales',
    NOTE = 'note',
    HIGHLIGHTER = 'highlighter',
    VALLEY_PLATE = 'valley_plate',
    UNDER_VALLEY_SHEATHING = 'under_valley_sheathing',
    WILDCARD_COUNT = 'wildcard_count_tool',
    WILDCARD_AREA = 'wildcard_area_tool',
    WILDCARD_LINE = 'wildcard_line_tool',
    EXTERIOR_ROOFING = 'exterior_roofing',
    FRAMING_ROOFING = 'framing_roofing',
    EAVE_LENGTH = 'eave_length',
    GABLE_LENGTH = 'gable_length',
    SIDING_STARTER = 'siding_starter',
    PORCH_CEILING = 'porch_ceiling',
    FLASHING = 'flashing',
    ROOF_LINE = 'roof_line',
    SCREEN_AREA = 'screen_area',
    LOUVER_HOG_FENCE = 'louver_hog_fence',
    BLOCK_ROUGH = 'block_rough',
    CANTILEVER_CLOSURE = 'cantilever_closure',
    SLOPE = 'slope',

    // W/D types
    NEW = 'new',
    WINDOW = 'window',
    PATIO = 'patio',
    INTERIOR_DOOR = 'interiorDoor',
    ENTRY_DOOR = 'entryDoor',
    VENT = 'vent',
    AI = 'ai',
    FLOOR_LINE = 'floorLine',
}

export const DRAWABLE_TYPES_LABELS = {
    [DRAWABLE_TYPES.APPLIANCE]: 'Appliance',
    [DRAWABLE_TYPES.NEW]: 'New',
    [DRAWABLE_TYPES.WINDOW]: 'Window',
    [DRAWABLE_TYPES.PATIO]: 'Patio Door',
    [DRAWABLE_TYPES.INTERIOR_DOOR]: 'Interior Door',
    [DRAWABLE_TYPES.ENTRY_DOOR]: 'Entry Door',
    [DRAWABLE_TYPES.EXTERIOR_DOOR]: 'Exterior Door',
    [DRAWABLE_TYPES.INTERIOR_DOOR_IMUP]: 'Interior Door',
    [DRAWABLE_TYPES.SIDING]: 'Siding',
    [DRAWABLE_TYPES.VENT]: 'Vent',
    [DRAWABLE_TYPES.AI]: 'AI',
    [DRAWABLE_TYPES.FLOOR_LINE]: 'Floor Line',
    [DRAWABLE_TYPES.ROOFING]: 'Roofing',
    [DRAWABLE_TYPES.TRIM]: 'Trim',
    [DRAWABLE_TYPES.CORNER]: 'Corner',
    [DRAWABLE_TYPES.POST_WRAP]: 'Post Wrap',
    [DRAWABLE_TYPES.WALL]: 'Wall',
    [DRAWABLE_TYPES.STAIRS]: 'Stairs',
    [DRAWABLE_TYPES.STAIR]: 'Stairs',
    [DRAWABLE_TYPES.POST]: 'Bearing Column',
    [DRAWABLE_TYPES.STEEL_BEAM_PLATE]: 'Steel Beam Plate',
    [DRAWABLE_TYPES.LF_RAILING]: 'L/F Railing',
    [DRAWABLE_TYPES.HARDWARE]: 'Hardware',
    [DRAWABLE_TYPES.INTERIOR_FINISHED_CEILING]: 'Interior Finished Ceiling',
    [DRAWABLE_TYPES.BASEMENT_FINISHED_CEILING]: 'Basement Finished Ceiling',
    [DRAWABLE_TYPES.FLOOR_TRUSS_BRACING]: 'Floor Truss Bracing',
    [DRAWABLE_TYPES.LEDGER]: 'Ledger',
    [DRAWABLE_TYPES.BLOCKING]: 'Blocking',
    [DRAWABLE_TYPES.BEAM]: 'Beam',
    [DRAWABLE_TYPES.LF_FIVE_DOT_FIVE_DECKING]: 'L/F 5.5" Decking',
    [DRAWABLE_TYPES.FOUNDATION_PILON]: 'Foundation Pilon',
    [DRAWABLE_TYPES.TRAYED_CEILING_AND_SOFFIT]: 'Trayed Ceiling and Soffit',
    [DRAWABLE_TYPES.FYPON_BRACKET]: 'Decorative Bracket',
    [DRAWABLE_TYPES.GABLE_AREA]: 'Gable Area',
    [DRAWABLE_TYPES.FLOOR_AREA]: 'Floor Area',
    [DRAWABLE_TYPES.SCREEN_AREA]: 'Screen Area',
    [DRAWABLE_TYPES.SHEARWALL]: 'Shearwall',
    [DRAWABLE_TYPES.UNDER_VALLEY_SHEATHING]: 'Under Valley Sheathing',
    [DRAWABLE_TYPES.CANALES]: 'Canales',
    [DRAWABLE_TYPES.VALLEY_PLATE]: 'Valley Plate',
    [DRAWABLE_TYPES.FRAMING_ROOFING]: 'Framing Roofing',
    [DRAWABLE_TYPES.EAVE_LENGTH]: 'Eave Length',
    [DRAWABLE_TYPES.GABLE_LENGTH]: 'Gable Length',
    [DRAWABLE_TYPES.FLOOR_SYSTEM]: 'Floor System',
    [DRAWABLE_TYPES.FLOOR_SYSTEMS]: 'Floor System',
    [DRAWABLE_TYPES.ROOF_SYSTEM]: 'Roof System',
    [DRAWABLE_TYPES.ROOF_SYSTEMS]: 'Roof System',
    [DRAWABLE_TYPES.EXTERIOR_ROOFING]: 'Exterior Roofing',
    [DRAWABLE_TYPES.ROOF_LINE]: 'Roof Line',
    [DRAWABLE_TYPES.FLASHING]: 'Flashing',
    [DRAWABLE_TYPES.SIDING_STARTER]: 'Siding Starter',
    [DRAWABLE_TYPES.PORCH_CEILING]: 'Porch Ceiling',
    [DRAWABLE_TYPES.WILDCARD_AREA]: 'Wildcard Area Tool',
    [DRAWABLE_TYPES.WILDCARD_COUNT]: 'Wildcard Count Tool',
    [DRAWABLE_TYPES.WILDCARD_LINE]: 'Wildcard Line Tool',
    [DRAWABLE_TYPES.LOUVER_HOG_FENCE]: 'Louver/Hog Fence',
    [DRAWABLE_TYPES.LF_SCREEN_OPENING]: 'L/F Screen Opening',
    [DRAWABLE_TYPES.BLOCK_ROUGH]: 'Block Rough Opening',
    [DRAWABLE_TYPES.CANTILEVER_CLOSURE]: 'Cantilever Closure',
    [DRAWABLE_TYPES.GARAGE_AREA]: 'Garage Area',
    [DRAWABLE_TYPES.PLUMBING_FIXTURE]: 'Plumbing Fixture',
    [DRAWABLE_TYPES.RIMBOARD]: 'Rimboard',
}

export const NEW_IMUP_JOIST_TYPES_GROUP = [
    DRAWABLE_TYPES.ROOF_SYSTEM,
    DRAWABLE_TYPES.ROOF_SYSTEMS,
    DRAWABLE_TYPES.FLOOR_SYSTEM,
    DRAWABLE_TYPES.FLOOR_SYSTEMS,
]

// drawable.settings.type
export enum DRAWABLE_SETTINGS_TYPES {
    RAFTER = 'rafter',
    I_JOIST = 'i-joist',
    CEILING_JOIST = 'ceiling joist',
    DIMENSIONAL_JOIST = 'dimensional joist',
    DIMENSIONAL_SLEEPER_JOIST = 'dimensional sleeper joist',
    FLOOR_TRUSS = 'floor truss',
    TRADITIONAL_JOIST = 'traditional joist',
    TRADITIONAL_SLEEPER_JOIST = 'traditional sleeper joist',
}

export enum BRIDGING_BLOCKING {
    BRIDGING = 'bridging',
    BLOCKING = 'blocking',
}
export enum DRAWABLE_SETTINGS_MATERIAL {
    DIMENSIONAL = 'dimensional',
    EWP = 'ewp',
    TRUSS = 'truss',
}

export enum IJOIST_BRAND {
    AJS = 'ajs',
    BCI = 'bci',
    LPI = 'lpi',
    PWI = 'pwi',
    TJI = 'tji',
}

export const COLOR_BY_BEAM_MATERIAL = {
    header: {
        color: '#8ffb19',
    },
    dropped_beam: {
        color: '#ff5733',
    },
    flush_beam: {
        color: '#ea27e4',
    },
    hip_and_valley_beam: {
        color: '#ffc300',
    },
    ridge_beam: {
        color: '#74a700',
    },
}

export const DRAWABLE_COLORS_BY_TYPE = {
    post_wrap: {
        color: '#7DCD85',
    },
    stairs: {
        color: '#CAA472',
    },
    stair: {
        color: '#CAA472',
    },
    post: {
        color: '#21d6a0',
    },
    steel_beam_plate: {
        color: '#ff3c97',
    },
    lf_railing: {
        color: '#15f001',
    },
    hardware: {
        color: '#ee8429',
    },
    'i-joist': {
        color: '#7a7d92',
    },
    ceiling_joist: {
        color: '#e6f356',
    },
    floor_joist: {
        color: '#c80fae',
    },
    sleeper_joist: {
        color: '#30b050',
    },
    roof_system: {
        color: '#3fff11',
    },
    roof_systems: {
        color: '#3fff11',
    },
    floor_system: {
        color: '#c9acc5',
    },
    floor_systems: {
        color: '#c9acc5',
    },
    dimensional_joist: {
        color: '#fdcece',
    },
    dimensional_sleeper_joist: {
        color: '#30b050',
    },
    floor_truss: {
        color: '#72c1fd',
    },
    rafter: {
        color: '#1b9fd5',
    },

    floor_truss_system: {
        color: '#72c1fd',
    },
    floor_truss_bracing: {
        color: '#a64d79',
    },

    ledger: {
        color: '#c9b949',
    },
    blocking: {
        color: '#c80fae',
    },
    automated_beam_and_header: {
        color: '#2b1618',
    },
    lf_fivedotfive_decking: {
        color: '#b21256',
    },
    foundation_pilon: {
        color: '#9c5eff',
    },
    trayed_ceiling_and_soffit: {
        color: '#acd269',
    },
    fypon_bracket: {
        color: '#c00c39',
    },
    floor_area: {
        color: '#94f2e7',
    },
    interior_finished_ceiling: {
        color: '#69b8fe',
    },
    basement_finished_ceiling: {
        color: '#d34af2',
    },
    canales: {
        color: '#2852fa',
    },
    exterior_door: {
        color: '#02ffff',
    },
    interior_door: {
        color: '#95a8fa',
    },
    valley_plate: {
        color: '#99d60b',
    },
    under_valley_sheathing: {
        color: '#99d60b',
    },
    gable_area: {
        color: '#9ea784',
    },
    louver_hog_fence: {
        color: '#008080',
    },
    block_rough: {
        color: '#30d5c8',
    },
    cantilever_closure: {
        color: '#0000ff',
    },
    lf_casing: {
        color: '#ff0f19',
    },
    king_stud: {
        color: '#ffa500',
    },
    shearwall: {
        color: '#ffa500',
    },
    garage_area: {
        color: '#0d9d49',
    },
    appliance: {
        color: '#03f664',
    },
    plumbing_fixture: {
        color: '#e88649',
    },
    ...COLOR_BY_BEAM_MATERIAL,
}

export const DRAWABLE_COLORS_BY_SELECTION = {
    aluminum: {
        label: 'aluminum',
        keyName: 'aluminum',
        color: '#F94144',
    },
    steel: {
        label: 'steel',
        keyName: 'steel',
        color: '#F94144',
    },
    steelShake: {
        label: 'steel shake',
        keyName: 'steelShake',
        color: '#F94144',
    },
    steelBB: {
        label: 'steel b&b',
        keyName: 'steelBB',
        color: '#F94144',
    },
    steelLap: {
        label: 'steel lap',
        keyName: 'steelLap',
        color: '#F94144',
    },
    sqft: {
        label: 'sq ft',
        keyName: 'sqft',
        color: '#F94144',
    },
    vinyl: {
        label: 'vinyl',
        keyName: 'vinyl',
        color: '#F3722C',
    },
    lpLap: {
        label: 'lp lap',
        keyName: 'lpLap',
        color: '#F3722C',
    },
    fiberCementLap: {
        label: 'fiber cement lap',
        keyName: 'fiberCementLap',
        color: '#F3722C',
    },
    stone: {
        label: 'stone',
        keyName: 'stone',
        color: '#F9844A',
    },
    smoothPanel: {
        label: 'smooth panel',
        keyName: 'smoothPanel',
        color: '#F8961E',
    },
    lpBB: {
        label: 'lp b&b',
        keyName: 'lpBB',
        color: '#F9C74F',
    },
    vinylBB: {
        label: 'vinyl b&b',
        keyName: 'vinylBB',
        color: '#F9C74F',
    },
    fiberCementBB: {
        label: 'fiber cement b&b',
        keyName: 'fiberCementBB',
        color: '#F9C74F',
    },
    lpShake: {
        label: 'lp shake',
        keyName: 'lpShake',
        color: '#90BE6D',
    },
    vinylShake: {
        label: 'vinyl shake',
        keyName: 'vinylShake',
        color: '#90BE6D',
    },
    fiberCementShake: {
        label: 'fiber cement shake',
        keyName: 'fiberCementShake',
        color: '#90BE6D',
    },
}

// export const DRAWABLE_COLORS_BY_MATERIAL_FIELD = {
//     solidBeam: {
//         label: 'solid beam',
//         keyName: 'solidBeam',
//         color: '#2f165d',
//     },
// }

// Materials whose name can be used to set the color
// this list is to prevent https://portal.myparadigm.com/browse/BLUEPRINTS-20685
// from occurring. I.e. a siding label is set that causes it to
// be coloured like roofing or eaves
export const DRAWABLE_NAME_COLOR_TYPES = [
    DRAWABLE_TYPES.PORCH_CEILING,
    DRAWABLE_TYPES.EAVE_LENGTH,
    DRAWABLE_TYPES.WALL,
    DRAWABLE_TYPES.CORNER,
    DRAWABLE_TYPES.GABLE_LENGTH,
    DRAWABLE_TYPES.EXTERIOR_ROOFING,
    DRAWABLE_TYPES.FRAMING_ROOFING,
]

// the order is matter, e.g. for walls names, we could have name with or without floor level,
// in this case, name which contain floor level should be before
export const DRAWABLE_COLORS_BY_NAME = {
    porchCeiling: {
        label: 'porch ceiling',
        keyName: 'porchCeiling',
        color: '#43AA8B',
    },
    eaveLength: {
        label: 'eave length',
        keyName: 'eaveLength',
        color: '#4D90BE',
    },
    gableLength: {
        label: 'gable length',
        keyName: 'gableLength',
        color: '#577590',
    },
    insideCorner: {
        label: 'inside corner',
        keyName: 'insideCorner',
        color: '#11B25F',
    },
    pv1: {
        label: 'pv 1',
        keyName: 'pv1',
        color: '#FF595E',
    },
    pv2: {
        label: 'pv 2',
        keyName: 'pv1',
        color: '#FF924C',
    },
    pv3: {
        label: 'pv 3',
        keyName: 'pv3',
        color: '#FFCA3A',
    },
    pv4: {
        label: 'pv 4',
        keyName: 'pv4',
        color: '#C5CA30',
    },
    pv5: {
        label: 'pv 5',
        keyName: 'pv5',
        color: '#8AC926',
    },
    pv6: {
        label: 'pv 6',
        keyName: 'pv6',
        color: '#36949D',
    },
    pv7: {
        label: 'pv 7',
        keyName: 'pv7',
        color: '#1982C4',
    },
    pv8: {
        label: 'pv 8',
        keyName: 'pv8',
        color: '#4267AC',
    },
    pv9: {
        label: 'pv 9',
        keyName: 'pv9',
        color: '#565AA0',
    },
    pv10: {
        label: 'pv 10',
        keyName: 'pv10',
        color: '#6A4C93',
    },
    pv11: {
        label: 'pv 11',
        keyName: 'pv11',
        color: '#59FFC8',
    },
    pv12: {
        label: 'pv 12',
        keyName: 'pv12',
        color: '#4DF0FF',
    },
    pv13: {
        label: 'pv 13',
        keyName: 'pv13',
        color: '#3BAAFF',
    },
    pv14: {
        label: 'pv 14',
        keyName: 'pv14',
        color: '#3059C9',
    },
    pv15: {
        label: 'pv 15',
        keyName: 'pv15',
        color: '#3426C9',
    },
    pv16: {
        label: 'pv 16',
        keyName: 'pv16',
        color: '#9E364C',
    },
    pv17: {
        label: 'pv 17',
        keyName: 'pv17',
        color: '#C4281A',
    },
    pv18: {
        label: 'pv 18',
        keyName: 'pv18',
        color: '#AB6641',
    },
    ev1: {
        label: 'ev 1',
        keyName: 'ev1',
        color: '#FF595E',
    },
    ev2: {
        label: 'ev 2',
        keyName: 'ev2',
        color: '#FF924C',
    },
    ev3: {
        label: 'ev 3',
        keyName: 'ev3',
        color: '#FFCA3A',
    },
    ev4: {
        label: 'ev 4',
        keyName: 'ev4',
        color: '#C5CA30',
    },
    ev5: {
        label: 'ev 5',
        keyName: 'ev5',
        color: '#8AC926',
    },
    ev6: {
        label: 'ev 6',
        keyName: 'ev6',
        color: '#36949D',
    },
    ev7: {
        label: 'ev 7',
        keyName: 'ev7',
        color: '#1982C4',
    },
    ev8: {
        label: 'ev 8',
        keyName: 'ev8',
        color: '#4267AC',
    },
    ev9: {
        label: 'ev 9',
        keyName: 'ev9',
        color: '#565AA0',
    },
    ev10: {
        label: 'ev 10',
        keyName: 'ev10',
        color: '#6A4C93',
    },
    ev11: {
        label: 'ev 11',
        keyName: 'ev11',
        color: '#59FFC8',
    },
    ev12: {
        label: 'ev 12',
        keyName: 'ev12',
        color: '#4DF0FF',
    },
    ev13: {
        label: 'ev 13',
        keyName: 'ev13',
        color: '#3BAAFF',
    },
    ev14: {
        label: 'ev 14',
        keyName: 'ev14',
        color: '#3059C9',
    },
    ev15: {
        label: 'ev 15',
        keyName: 'ev15',
        color: '#3426C9',
    },
    ev16: {
        label: 'ev 16',
        keyName: 'ev16',
        color: '#9E364C',
    },
    ev17: {
        label: 'ev 17',
        keyName: 'ev17',
        color: '#C4281A',
    },
    ev18: {
        label: 'ev 18',
        keyName: 'ev18',
        color: '#AB6641',
    },
    exteriorCabinetOrVanityWall: {
        label: 'exterior cabinet or vanity wall',
        keyName: 'exteriorCabinetOrVanityWall',
        color: '#0000ff',
    },
    exteriorEWPWall: {
        label: 'exterior ewp wall',
        keyName: 'exteriorEWPWall',
        color: '#0000ff',
    },
    blockExteriorWall: {
        label: 'block exterior wall',
        keyName: 'blockExteriorWall',
        color: '#0000ff',
    },
    blockExteriorCabinetOrVanityWall: {
        label: 'block exterior cabinet or vanity wall',
        keyName: 'blockExteriorCabinetOrVanityWall',
        color: '#0000ff',
    },
    walkOutWall: {
        label: 'walk out wall',
        keyName: 'walkOutWall',
        color: '#0000ff',
    },
    garageExteriorWall: {
        label: 'garage exterior wall',
        keyName: 'garageExteriorWall',
        color: '#8ac926',
    },
    interiorCabinetOrVanityWall: {
        label: 'interior cabinet or vanity wall',
        keyName: 'interiorCabinetOrVanityWall',
        color: '#8338ec',
    },
    interiorEWPWall: {
        label: 'interior ewp wall',
        keyName: 'interiorEWPWall',
        color: '#8338ec',
    },
    blockInteriorWall: {
        label: 'block interior wall',
        keyName: 'blockInteriorWall',
        color: '#8338ec',
    },
    blockInteriorCabinetOrVanityWall: {
        label: 'block interior cabinet or vanity wall',
        keyName: 'blockInteriorCabinetOrVanityWall',
        color: '#8338ec',
    },
    blockFireWall: {
        label: 'block fire wall',
        keyName: 'blockFireWall',
        color: '#cc0c0c',
    },
    blockPartyWall: {
        label: 'block party wall',
        keyName: 'blockPartyWall',
        color: '#e36414',
    },
    blockFoundationWall: {
        label: 'block foundation wall',
        keyName: 'blockFoundationWall',
        color: '#335c67',
    },
    parapetWall: {
        label: 'parapet wall',
        keyName: 'parapetWall',
        color: '#0000ff',
    },
    interiorWall: {
        label: 'interior wall',
        keyName: 'interiorWall',
        color: '#8338ec',
    },
    perimeterWall: {
        label: 'perimeter wall',
        keyName: 'perimeterWall',
        color: '#8338ec',
    },
    bearingWall: {
        label: 'bearing wall',
        keyName: 'bearingWall',
        color: '#00bbf9',
    },
    fireWall: {
        label: 'fire wall',
        keyName: 'fireWall',
        color: '#cc0c0c',
    },
    kneeWall: {
        label: 'knee wall',
        keyName: 'kneeWall',
        color: '#f72585',
    },
    partyWall: {
        label: 'party wall',
        keyName: 'partyWall',
        color: '#e36414',
    },
    foundationWall: {
        label: 'foundation wall',
        keyName: 'foundationWall',
        color: '#335c67',
    },
    exteriorWall: {
        label: 'exterior wall',
        keyName: 'exteriorWall',
        color: '#0000ff',
    },
}

export const DRAWABLE_COLORS_BY_LOCATION = {
    top: {
        label: 'top',
        keyName: 'top',
        color: '#277DA1',
    },
    legs: {
        label: 'legs',
        keyName: 'legs',
        color: '#41F7FA',
    },
    bottom: {
        label: 'bottom',
        keyName: 'bottom',
        color: '#2CA6F2',
    },
    windowStill: {
        label: 'window still',
        keyName: 'windowStill',
        color: '#1E78F7',
    },
    crownMold: {
        label: 'crown mold',
        keyName: 'crownMold',
        color: '#4BBAFA',
    },
    accent: {
        label: 'accent',
        keyName: 'accent',
        color: '#507DFA',
    },
    bendBoard: {
        label: 'bend board',
        keyName: 'bendBoard',
        color: '#9E6DBF',
    },
    waterTable: {
        label: 'water table',
        keyName: 'waterTable',
        color: '#AB435E',
    },
    beamWrap: {
        label: 'beam wrap',
        keyName: 'beamWrap',
        color: '#8F4C4C',
    },
    undersideBeamWrap: {
        label: 'underside beam wrap',
        keyName: 'undersideBeamWrap',
        color: '#8F7256',
    },
    cap: {
        label: 'cap',
        keyName: 'cap',
        color: '#A14F27',
    },
    deckFascia: {
        label: 'deck fascia',
        keyName: 'deckFascia',
        color: '#8AC926',
    },
}

const SIDING_COLOR = 'rgb(239, 71, 111)'
const ROOFING_COLOR = 'rgb(255, 209, 102)'

export const SELECTED_AI_SUGGESTION_COLOR = 'rgb(255, 0, 0)'

const REFLECTED_GRADIENT_COLORS = {
    blue: {
        outer: 'rgb(0, 82, 204)',
        inner: 'rgb(0, 255, 255)',
    },
    green: {
        outer: 'rgb(13, 199, 0)',
        inner: 'rgb(188, 255, 183)',
    },
    pink: {
        outer: 'rgb(249, 12, 210)',
        inner: 'rgb(255, 219, 248)',
    },
    orange: {
        outer: 'rgb(255, 95, 31)',
        inner: 'rgb(255, 175, 15)',
    },
}

export const AI_MATERIAL_REFLECTED_GRADIENT_COLORS = {
    trim: {
        outerColor: REFLECTED_GRADIENT_COLORS.pink.outer,
        innerColor: REFLECTED_GRADIENT_COLORS.pink.inner,
    },
    wall: {
        outerColor: REFLECTED_GRADIENT_COLORS.blue.outer,
        innerColor: REFLECTED_GRADIENT_COLORS.blue.inner,
    },
    header: {
        outerColor: REFLECTED_GRADIENT_COLORS.green.outer,
        innerColor: REFLECTED_GRADIENT_COLORS.green.inner,
    },
    eave_length: {
        outerColor: REFLECTED_GRADIENT_COLORS.orange.outer,
        innerColor: REFLECTED_GRADIENT_COLORS.orange.inner,
    },
    gable_length: {
        outerColor: REFLECTED_GRADIENT_COLORS.green.outer,
        innerColor: REFLECTED_GRADIENT_COLORS.green.inner,
    },
    hip_and_valley_beam: {
        outerColor: REFLECTED_GRADIENT_COLORS.pink.outer,
        innerColor: REFLECTED_GRADIENT_COLORS.pink.inner,
    },
    ridge_beam: {
        outerColor: REFLECTED_GRADIENT_COLORS.blue.outer,
        innerColor: REFLECTED_GRADIENT_COLORS.blue.inner,
    },
    default: {
        outerColor: REFLECTED_GRADIENT_COLORS.orange.outer,
        innerColor: REFLECTED_GRADIENT_COLORS.orange.inner,
    },
}

// default colors
export const DRAWABLE_TYPES_COLORS = {
    window: 'rgb(232, 134, 73)',
    patio: 'rgb(45, 216, 206)',
    interiorDoor: 'rgb(170, 68, 153)',
    entryDoor: 'rgb(120, 94, 240)',
    siding: SIDING_COLOR,
    vent: 'transparent',
    section: 'rgb(232, 134, 73)',
    area: 'rgb(45, 216, 206)',
    point: 'rgb(45, 125, 216)',
    ai: 'rgb(45, 125, 216)',
    floorLine: 'rgb(66, 123, 204)',
    roofing: ROOFING_COLOR,
    trim: 'rgb(6, 214, 160)',
    corner: 'rgb(17, 138, 178)',
    post_wrap: 'rgb(7, 59, 76)',
    le_window: 'rgb(232, 134, 73)',
    le_door: 'rgb(45, 125, 216)',
    le_unknown: 'rgb(45, 125, 216)',
    sidelight: 'rgb(120, 94, 240)',
    plumbing_fixture: 'rgb(232, 134, 73)',
    le_joist: 'rgb(67, 122, 135)',
    valley_plate: 'rgb(153, 214, 11)',
    under_valley_sheathing: 'rgb(153, 214, 11)',
    [DRAWABLE_TYPES.WILDCARD_AREA]: 'rgb(45, 125, 216)',
    [DRAWABLE_TYPES.WILDCARD_COUNT]: 'rgb(45, 125, 216)',
    [DRAWABLE_TYPES.WILDCARD_LINE]: 'rgb(45, 125, 216)',
    [DRAWABLE_TYPES.SIDING_STARTER]: SIDING_COLOR,
    [DRAWABLE_TYPES.FLASHING]: ROOFING_COLOR,
    [DRAWABLE_TYPES.ROOF_LINE]: ROOFING_COLOR,
}

export enum DRAWING_TYPES {
    SECTION = 'section',
    AREA = 'area',
    POINT = 'point',
    RADIUS = 'radius',
    FLAG = 'flag',
}

/**
 * AI opening types for takeoff are stored in ClassIds. Docs on which number stands for which type is here:
 * https://confluence.myparadigm.com/pages/viewpage.action?pageId=82871644 - floor
 * https://confluence.myparadigm.com/pages/viewpage.action?pageId=86344723 - elevation
 */

export const AI_DRAWABLE_EL_TYPES = {
    0: DRAWABLE_TYPES.WINDOW, // Rectangular
    1: DRAWABLE_TYPES.WINDOW, // Non-Rectangular
    2: DRAWABLE_TYPES.ENTRY_DOOR, // Garage Door
    3: DRAWABLE_TYPES.ENTRY_DOOR, // Service Door
    4: DRAWABLE_TYPES.ENTRY_DOOR, // Entry Door
    5: DRAWABLE_TYPES.PATIO,
    6: DRAWABLE_TYPES.ENTRY_DOOR, // Sidelite
    7: DRAWABLE_TYPES.WINDOW, // Transom
    8: DRAWABLE_TYPES.VENT,
}

export const AI_DRAWABLE_FLOOR_TYPES = {
    0: DRAWABLE_TYPES.INTERIOR_DOOR, // bi_fold_door
    1: DRAWABLE_TYPES.INTERIOR_DOOR, // Double_door
    2: DRAWABLE_TYPES.ENTRY_DOOR, // Garage Door
    3: DRAWABLE_TYPES.ENTRY_DOOR, // left_door
    4: DRAWABLE_TYPES.ENTRY_DOOR, // right_door
    5: DRAWABLE_TYPES.WINDOW, // window
    6: DRAWABLE_TYPES.ENTRY_DOOR, // barn_door
    7: DRAWABLE_TYPES.INTERIOR_DOOR, // by_pass_door
    8: DRAWABLE_TYPES.PATIO, // patio_door
    9: DRAWABLE_TYPES.INTERIOR_DOOR, // pocket door
    10: DRAWABLE_TYPES.INTERIOR_DOOR, // sliding door
    11: DRAWABLE_TYPES.INTERIOR_DOOR, // cased opening (a door way w/o)
}

export enum PAPER_ELEMENT_TYPE {
    AI_SUGGESTION = 'ai suggestion',
    DRAWABLE = 'drawable',
    FLAG = 'flag',
    HIGHLIGHT = 'highlight',
    MASTER_SET_PLAN_OPTION = 'master set plan option',
    MODIFICATION = 'modification',
    MODIFICATION_TO_EDIT = 'modification to edit',
    NEW_MASTER_SET_CLASSIFICATION = 'new master set classification',
    REGION = 'region',
    TOOL_OBJECT = 'tool object',
}

// paper.js `Item#name` (not `.data.type` above) set on an overlay's raster image by
// Overlay.tool.ts, and read by Select.tool.ts to recognize a raster click once overlays are
// locked/saved and Select becomes the active tool.
export const OVERLAY_RASTER_ITEM_NAME = 'Raster'
